import { Vue } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios from 'axios';
import 'url-search-params-polyfill';
import {CONFIG_ENV} from '@/config';
import iNomCateg from '@/types/iNomCateg';
import nomenclatoare from '@/store/nomenclatoare';
import iDocumentIntrare from '@/types/iDocumentIntrare';
import iDocument from '@/types/iDocument';

type OrNull<T> = { [K in keyof T]: T[K] | null }
type IDocumentIntrare = OrNull<iDocumentIntrare>;

interface TAjaxResponsePostDocument {
  status: string;
  message: string;
  appid: number;
}

interface TAjaxResponseGetDocument {
  status: string;
  message: string;
  document: IDocumentIntrare;
  denTipDocument: string;
}

interface TAjaxResponseGetPdfCoverDocumentt {
  data: string;
}

interface TAjaxResponseMyDocuments {
  status: string;
  message: string;
  rows: iDocument[];
}

interface TAjaxResponseGetFastSearch{
  status: string;
  message: string;
  nr_of_records: number,
  rows: iDocument[];
}

export class ServicesDocument {
  // tslint:disable-next-line:max-line-length
  public static async postDocumentIntrare(pdocApp: IDocumentIntrare): Promise<TAjaxResponsePostDocument> {
    const response = await axios.post(`${CONFIG_ENV.URL_DOCUMENT.doc_intrare}`, pdocApp);
    return response.data;
  }

  public static async getDocumentIntrare(appid: number): Promise<TAjaxResponseGetDocument> {
    const response = await axios.get(`${CONFIG_ENV.URL_DOCUMENT.doc_intrare}/${appid}`);
    return response.data;
  }

  public static async FastSearch(ptext: string): Promise<TAjaxResponseGetFastSearch> {
    const params = new URLSearchParams();
    params.set('fast_search_text', ptext);
    const response = await axios.post(`${CONFIG_ENV.URL_DOCUMENT.FastSearch}`, params);
    return response.data;
  }

  public static async getMyDocuments(): Promise<TAjaxResponseMyDocuments> {
    const response = await axios.get(`${CONFIG_ENV.URL_DOCUMENT.MyDocuments}`);
    return response.data;
  }

  public static async getMyDocumentsWithNoScan(): Promise<TAjaxResponseMyDocuments> {
    const response = await axios.get(`${CONFIG_ENV.URL_DOCUMENT.MyDocumentsWithNoScan}`);
    return response.data;
  }

  public static async getPdfCoverDocument(appid: number): Promise<TAjaxResponseGetPdfCoverDocumentt> {
    const response = await axios({
                                          url: `${CONFIG_ENV.URL_DOCUMENT.pdf_cover}/${appid}`,
                                          method: 'GET',
                                          responseType: 'blob', // important
                                        });
    return response;
  }


}
